import React, { useMemo } from "react";
import "../Zone/Zone.css";
import "./Ward.css";
import { normalizeWard } from "../../Utils/ward";

function pctStatusColor(sc) {
  if (sc === "ok") return "#3d7a50";
  if (sc === "warn") return "#7a6030";
  return "#7a3030";
}

function Ward({ className, zone, ward, locationsData, onBack, onLocationClick }) {
  const pcts = useMemo(() => {
    if (!locationsData || !zone || !ward) return [];
    return Object.entries(locationsData)
      .filter(
        ([, l]) =>
          String(l.zone) === String(zone.id) &&
          normalizeWard(l.ward) === normalizeWard(ward.id)
      )
      .map(([id, l]) => {
        const taken = l.takeoverTime != null;
        const state = l.operationalStatus?.state;
        const sc = taken ? "ok" : state === "Active" ? "warn" : "bad";
        const now = Date.now();
        let comp;
        if (taken) {
          comp = 100;
        } else if (l.constructionStartedAt && l.estimatedTakeoverTime) {
          const total = l.estimatedTakeoverTime - l.constructionStartedAt;
          comp = total > 0
            ? Math.round(Math.max(0, Math.min(100, ((l.estimatedTakeoverTime - now) / total) * 100)))
            : 0;
        } else {
          comp = state === "Active" ? 60 : 0;
        }
        const status = taken ? "Taken Over" : state || "Inactive";
        return { id, sc, comp, status, pctNo: l.PCTNo || null, location: l.location || null };
      })
      .sort((a, b) => a.id.localeCompare(b.id));
  }, [locationsData, zone, ward]);

  if (!zone || !ward) return null;

  const operational = ward.takenOver || 0;
  const inProgress = ward.active || 0;
  const pending = (ward.total || 0) - (ward.takenOverAndActive || 0);

  const sc = ward.completionPct >= 80 ? "ok" : ward.completionPct >= 60 ? "warn" : "bad";
  const scLabel = { ok: "On track", warn: "Watch", bad: "At risk" }[sc];

  return (
    <div className={className} data-cy="ward-screen">
      <div className="subhdr">
        <div className="back" onClick={onBack}>
          <svg viewBox="0 0 24 24">
            <polyline points="15,18 9,12 15,6" />
          </svg>
        </div>
        <div className="subhdr-info">
          <div className="subhdr-crumb">Chennai › Zone {zone.id}</div>
          <div className="subhdr-title">Ward {ward.id}</div>
        </div>
        <span className={`pill ${sc}`}>
          <span className="dot" />
          {scLabel}
        </span>
      </div>
      <div className="divider" />
      <div className="scroll">
        <div style={{ padding: "6px 20px 10px", fontSize: "var(--text-base)", color: "var(--t2)" }}>
          {ward.total} PCTs
        </div>
        <div className="stats c3" style={{ marginBottom: "16px" }}>
          <div className="stat">
            <div className="stat-n" style={{ color: "#5fbe7a" }}>{operational}</div>
            <div className="stat-l">Taken Over</div>
          </div>
          <div className="stat">
            <div className="stat-n" style={{ color: "#c39a52" }}>{inProgress}</div>
            <div className="stat-l">Active</div>
          </div>
          <div className="stat">
            <div className="stat-n" style={{ color: "var(--t2)" }}>{pending}</div>
            <div className="stat-l">Pending</div>
          </div>
        </div>
        <div className="sec-hdr">
          <div className="t-section">PCTs</div>
          <div className="t-label">{pcts.length} PCTs</div>
        </div>
        <div className="pgrid">
          {pcts.map((p) => {
            const color = pctStatusColor(p.sc);
            return (
              <div key={p.id} className="pcell" data-cy={`pct-cell-${p.id}`} onClick={() => onLocationClick && onLocationClick(p.id)}>
                <div className="pid">{p.location || `PCT ${p.id}`}</div>
                <div className="pnm">{p.pctNo || `PCT ${p.id}`}</div>
                <div className="pbar">
                  <div className="pfill" style={{ width: `${p.comp}%`, background: color }} />
                </div>
                <div className="pfoot">
                  <div className="ppct">{p.comp}%</div>
                  <span className={`pill ${p.sc}`}>
                    <span className="dot" />
                    {p.status}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
        <div style={{ height: "20px" }} />
      </div>
    </div>
  );
}

export default Ward;
